import React, { useEffect, useState } from 'react';
import { ShieldIcon, ClockIcon, LockIcon, ArrowRightIcon, UsersIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  const [viewers, setViewers] = useState(47);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(Math.floor(Math.random() * (56 - 38 + 1) + 38));
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative pt-20 pb-16 md:pt-28 md:pb-24 overflow-hidden bg-gradient-to-br from-beige to-blush" data-id="element-98">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-99">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-rose opacity-20 rounded-full blur-3xl" data-id="element-100"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 bg-coral opacity-10 rounded-full blur-3xl" data-id="element-101"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-4xl text-center fade-in-section" data-id="element-102">
        <div className="flex items-center justify-center gap-2 mb-4 text-sm font-medium text-coral-dark bg-white/50 inline-flex px-3 py-1 rounded-full backdrop-blur-sm border border-coral/10" data-id="element-103">
          <span className="relative flex h-2 w-2" data-id="element-104">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-coral opacity-75" data-id="element-105"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-coral" data-id="element-106"></span>
          </span>
          🔥 {viewers} personas están viendo esta oferta ahora mismo
        </div>
        <br data-id="element-107" />
        <div className="inline-flex items-center justify-center px-4 py-1.5 mb-6 rounded-full bg-white shadow-soft border border-rose/30" data-id="element-108">
          <span className="flex h-2 w-2 rounded-full bg-coral mr-2 animate-pulse" data-id="element-109"></span>
          <span className="text-sm font-semibold text-coral-dark uppercase tracking-wider" data-id="element-110">
            Atención Mujeres de 24 a 65 años
          </span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-text-dark leading-tight mb-6" data-id="element-111">
          ¿Cansada de hacer dietas que no funcionan y{' '}
          <span className="text-coral" data-id="element-112">sentirte cada vez peor</span>?
        </h1>

        <p className="text-lg md:text-xl text-text-medium mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-113">
          Descubrí el método natural de 21 días que ya ayudó a más de 3.000
          mujeres a reiniciar su metabolismo, desinflamar su cuerpo y bajar de
          peso{' '}
          <strong className="text-text-dark font-bold" data-id="element-114">sin pasar hambre</strong>
          .
        </p>

        {/* Product Mockup */}
        <div className="flex justify-center mb-12" data-id="element-115">
          <img src="https://cdn.magicpatterns.com/uploads/umzz8XAY7m6m7AP2G1RzaV/heylloyd-image-1774018192199.png" alt="Reinicia tu Metabolismo en 21 Días - Ebook y versión móvil" className="w-full max-w-lg md:max-w-xl rounded-2xl drop-shadow-xl animate-float" data-id="element-116" />
        </div>

        <div className="flex flex-col items-center" data-id="element-117">
          <a href="https://reiniciatumetabolismo.lat/cart/43809396064391:1?checkout" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-bold text-white bg-coral rounded-full shadow-cta hover:bg-coral-dark transition-all duration-300 animate-pulse-soft animate-shimmer w-full sm:w-auto" data-id="element-118">
            Sí, quiero reiniciar mi metabolismo
            <ArrowRightIcon className="ml-2 group-hover:translate-x-1 transition-transform" size={24} data-id="element-119" />
          </a>

          <p className="text-xs text-text-medium mt-3 mb-2" data-id="element-120">
            → Acceso inmediato después del pago
          </p>

          <div className="flex flex-wrap justify-center items-center gap-4 mt-4 text-sm text-text-medium" data-id="element-121">
            <div className="flex items-center" data-id="element-122">
              <LockIcon size={16} className="mr-1.5 text-sage" data-id="element-123" />
              <span data-id="element-124">Pago seguro</span>
            </div>
            <span className="hidden sm:inline text-gray-300" data-id="element-125">•</span>
            <div className="flex items-center" data-id="element-126">
              <ClockIcon size={16} className="mr-1.5 text-sage" data-id="element-127" />
              <span data-id="element-128">Acceso inmediato</span>
            </div>
            <span className="hidden sm:inline text-gray-300" data-id="element-129">•</span>
            <div className="flex items-center" data-id="element-130">
              <ShieldIcon size={16} className="mr-1.5 text-sage" data-id="element-131" />
              <span data-id="element-132">Garantía 7 días</span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-1 mt-4 text-xs font-medium text-text-dark bg-white/60 px-3 py-1.5 rounded-full shadow-sm" data-id="element-133">
            <StarIcon className="w-3.5 h-3.5 text-yellow-500 fill-current" data-id="element-134" />
            <span data-id="element-135">4.8/5 basado en +3.000 mujeres</span>
          </div>
        </div>
      </div>
    </section>;
}